module.exports = __webpack_public_path__ + "img/business.4e6732a.png";